module.exports = __webpack_public_path__ + "images/h4badc9bc2f2075f3d55c7d4f0d034f2df.png";